(function () {
  const STORAGE_KEY = "sob_cart_box_v1";
  const STORAGE_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 7;
  const HTML_BOX_CLASS = "sob-cart-has-local-box";

  let refreshTimer = null;
  let isApplying = false;
  let observer = null;

  function safeParse(json) {
    try { return JSON.parse(json); } catch (e) { return null; }
  }

  function safeGetStorage() {
    try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function safeSetStorage(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function safeRemoveStorage() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function validateBox(box) {
    if (!box || typeof box !== "object") return false;
    if (box.version !== 1) return false;
    if (!Array.isArray(box.items) || !box.items.length) return false;
    if (typeof box.id !== "string" || !box.id) return false;
    if (typeof box.configUrl !== "string" || !box.configUrl) return false;
    if (!Number.isFinite(Number(box.createdAt))) return false;
    if (Date.now() - Number(box.createdAt) > STORAGE_MAX_AGE_MS) return false;

    return box.items.every(function (item) {
      return (
        item &&
        Number.isFinite(Number(item.variantId)) &&
        Number(item.variantId) > 0 &&
        Number.isFinite(Number(item.qty)) &&
        Number(item.qty) > 0 &&
        (item.role === "meal" || item.role === "extra")
      );
    });
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function moneyFromCents(cents) {
    try {
      if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents, window.sobMoneyFormat || "${{amount}}");
      }
    } catch (e) {}
    return (Number(cents || 0) / 100).toFixed(2) + " €";
  }

  function cleanLabel(label) {
    return String(label || "")
      .replace("🟢 ", "")
      .replace("Box_", "")
      .replace("Box ", "")
      .trim();
  }

  function buildRecomposeUrl(url) {
    try {
      const absoluteUrl = new URL(url, window.location.origin);
      absoluteUrl.searchParams.set("sob_recompose", "1");
      return absoluteUrl.pathname + absoluteUrl.search;
    } catch (e) {
      return url;
    }
  }

  function getCartRows() {
    return Array.from(document.querySelectorAll("[data-sob-cart-item]"));
  }

  function clearPreviousRender(rows) {
    const existingCard = document.querySelector("[data-sob-rendered-box]");
    if (existingCard) existingCard.remove();

    rows.forEach(function (row) {
      const badges = row.querySelector("[data-sob-role-badges]");
      if (badges) {
        badges.innerHTML = "";
        badges.dataset.sobInjected = "";
      }

      row.querySelectorAll("[data-sob-inline-price], [data-sob-total-mobile], [data-sob-total-desktop]")
        .forEach(function (node) {
          node.classList.remove("sob-cart-meal-hide-price");
          node.classList.remove("sob-cart-price-visible");
        });
    });
  }

  function buildRowMap(rows) {
    const map = new Map();

    rows.forEach(function (row) {
      const variantId = Number(row.getAttribute("data-sob-variant-id"));
      if (!Number.isFinite(variantId)) return;

      if (!map.has(variantId)) map.set(variantId, []);
      map.get(variantId).push(row);
    });

    map.forEach(function (list) {
      list.sort(function (a, b) {
        return Number(a.getAttribute("data-sob-line-index")) - Number(b.getAttribute("data-sob-line-index"));
      });
    });

    return map;
  }

  function aggregateBoxItems(box) {
    const map = new Map();

    box.items.forEach(function (item) {
      const variantId = Number(item.variantId);
      const key = item.role + "::" + variantId;
      const existing = map.get(key) || {
        variantId: variantId,
        qty: 0,
        role: item.role,
        title: item.title || "",
        extraKind: item.extraKind || ""
      };

      existing.qty += Number(item.qty || 0);
      map.set(key, existing);
    });

    return Array.from(map.values());
  }

  function syncBoxWithCart(box, rows) {
    const rowMap = buildRowMap(rows);
    const aggregatedItems = aggregateBoxItems(box);
    const matchedRows = [];

    aggregatedItems.forEach(function (item) {
      const candidateRows = rowMap.get(Number(item.variantId)) || [];
      if (!candidateRows.length) return;

      const row = candidateRows[0];

      matchedRows.push({
        row: row,
        item: item,
        variantId: Number(item.variantId),
        lineIndex: Number(row.getAttribute("data-sob-line-index")),
        linePrice: Number(row.getAttribute("data-sob-line-price") || 0),
        quantity: Number(row.getAttribute("data-sob-quantity") || 0)
      });
    });

    const meals = matchedRows.filter(function (entry) {
      return entry.item.role === "meal";
    });

    if (!meals.length) return null;

    const syncedBox = {
      version: 1,
      id: String(box.id),
      label: String(box.label || ""),
      configUrl: String(box.configUrl || window.location.pathname + window.location.search),
      planLabel: String(box.planLabel || "Achat unique — sans abonnement"),
      min: Number(box.min || 0),
      max: Number(box.max || 0),
      totalMeals: meals.reduce(function (sum, entry) {
        return sum + Number(entry.quantity || 0);
      }, 0),
      createdAt: Number(box.createdAt || Date.now()),
      items: matchedRows.map(function (entry) {
        return {
          variantId: Number(entry.variantId),
          qty: Number(entry.quantity),
          title: String(entry.item.title || ""),
          role: entry.item.role,
          extraKind: String(entry.item.extraKind || "")
        };
      })
    };

    return {
      box: syncedBox,
      matchedRows: matchedRows
    };
  }

  function injectRoleBadgesAndManagePrices(matchedRows) {
    matchedRows.forEach(function (entry) {
      const row = entry.row;
      const container = row.querySelector("[data-sob-role-badges]");

      if (container && container.dataset.sobInjected !== "true") {
        container.innerHTML = '<span class="sob-cart-line-badge">' + (entry.item.role === "meal" ? "Repas" : "Extra") + "</span>";
        container.dataset.sobInjected = "true";
      }

      row.querySelectorAll("[data-sob-inline-price], [data-sob-total-mobile], [data-sob-total-desktop]")
        .forEach(function (node) {
          if (entry.item.role === "meal") {
            node.classList.add("sob-cart-meal-hide-price");
            node.classList.remove("sob-cart-price-visible");
          } else {
            node.classList.add("sob-cart-price-visible");
          }
        });
    });
  }

  function renderBoxCard(box, matchedRows) {
    if (!matchedRows || !matchedRows.length) return;

    const sortedRows = matchedRows.slice().sort(function (a, b) {
      return Number(a.lineIndex) - Number(b.lineIndex);
    });

    const firstRow = sortedRows[0] && sortedRows[0].row;
    if (!firstRow || !firstRow.parentNode) return;

    let mealsTotal = 0;
    let extrasTotal = 0;
    let mealsQty = 0;

    matchedRows.forEach(function (entry) {
      if (entry.item.role === "meal") {
        mealsTotal += entry.linePrice;
        mealsQty += entry.quantity;
      } else {
        extrasTotal += entry.linePrice;
      }
    });

    const wrapper = document.createElement("tr");
    wrapper.className = "sob-cart-box-row";
    wrapper.setAttribute("data-sob-rendered-box", "true");

    wrapper.innerHTML =
      '<td colspan="5">' +
        '<div class="sob-cart-box-card">' +
          '<div class="sob-cart-box-head">' +
            '<div>' +
              '<h3 class="sob-cart-box-title">Inclus dans votre box ' + escapeHtml(cleanLabel(box.label)) + '</h3>' +
              '<div class="sob-cart-box-meta">' +
                (box.planLabel ? '<div>Formule : ' + escapeHtml(box.planLabel) + '</div>' : '') +
                (mealsQty > 0 ? '<div>' + mealsQty + ' repas sélectionnés</div>' : '') +
                '<div><strong>Prix de votre box repas :</strong> ' + escapeHtml(moneyFromCents(mealsTotal)) + '</div>' +
                (extrasTotal > 0 ? '<div><strong>Total extras :</strong> ' + escapeHtml(moneyFromCents(extrasTotal)) + '</div>' : '') +
              '</div>' +
            '</div>' +
            '<div class="sob-cart-box-actions">' +
  '<a href="' + escapeHtml(buildRecomposeUrl(box.configUrl)) + '" class="sob-cart-box-link">Recomposer ma box</a>' +
  '<button type="button" class="sob-cart-box-remove" data-sob-box-remove-local>Supprimer la box</button>' +
'</div>' +
          '</div>' +
        '</div>' +
      '</td>';

    firstRow.parentNode.insertBefore(wrapper, firstRow);

    const removeBtn = wrapper.querySelector("[data-sob-box-remove-local]");
    if (removeBtn) {
      removeBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        removeEntireBox(removeBtn, matchedRows);
      });
    }
  }

  async function removeEntireBox(button, matchedRows) {
    if (!button || button.disabled) return;
    if (!window.confirm("Supprimer toute cette box du panier ?")) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = "Suppression...";

    try {
      const lineIndexes = matchedRows
        .map(function (entry) { return Number(entry.lineIndex); })
        .filter(function (index) { return Number.isFinite(index) && index > 0; })
        .sort(function (a, b) { return b - a; });

      for (const lineIndex of lineIndexes) {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            line: lineIndex,
            quantity: 0
          })
        });

        if (!response.ok) throw new Error("Erreur suppression box");
      }

      safeRemoveStorage();
      document.documentElement.classList.remove(HTML_BOX_CLASS);
      window.location.reload();
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = originalText;
      alert("Une erreur s'est produite lors de la suppression de la box.");
    }
  }

  function refreshCartBoxUI() {
    if (isApplying) return;
    isApplying = true;

    try {
      const rows = getCartRows();

      if (!rows.length) {
        safeRemoveStorage();
        document.documentElement.classList.remove(HTML_BOX_CLASS);
        return;
      }

      clearPreviousRender(rows);

      const raw = safeGetStorage();
      if (!raw) {
        document.documentElement.classList.remove(HTML_BOX_CLASS);
        return;
      }

      const box = safeParse(raw);
      if (!validateBox(box)) {
        safeRemoveStorage();
        document.documentElement.classList.remove(HTML_BOX_CLASS);
        return;
      }

      document.documentElement.classList.add(HTML_BOX_CLASS);

      const synced = syncBoxWithCart(box, rows);
      if (!synced || !synced.matchedRows.length) {
        safeRemoveStorage();
        document.documentElement.classList.remove(HTML_BOX_CLASS);
        return;
      }

      safeSetStorage(JSON.stringify(synced.box));
      injectRoleBadgesAndManagePrices(synced.matchedRows);
      renderBoxCard(synced.box, synced.matchedRows);
    } finally {
      isApplying = false;
    }
  }

function scheduleRefresh() {
  window.clearTimeout(refreshTimer);

  refreshTimer = window.setTimeout(function () {
    requestAnimationFrame(function () {
      refreshCartBoxUI();
    });
  }, 700);
}

function startObserver() {
  // Désactivé volontairement pour fluidifier le panier mobile.
  // Le récap se met à jour via les clics + / - / supprimer / retour page.
  return;
}

  function init() {
    refreshCartBoxUI();
    startObserver();

   document.addEventListener("change", function (event) {
  if (event.target && event.target.matches(".quantity__input")) {
    setTimeout(scheduleRefresh, 900);
  }
});

    document.addEventListener("click", function (event) {
  if (
    event.target.closest(".quantity__button") ||
    event.target.closest("cart-remove-button")
  ) {
    setTimeout(scheduleRefresh, 900);
  }
});
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("pageshow", scheduleRefresh);
})();